import { Icon, type IconName } from './Icon';

/**
 * An empty list, said as an invitation rather than an absence.
 *
 * The title names what is missing and the hint says what would put something
 * there, so a new dashboard reads as "ready" instead of "broken".
 */
export function Empty({
  title,
  hint,
  testId,
  icon,
}: {
  title: string;
  hint?: string;
  testId?: string;
  icon?: IconName;
}): React.JSX.Element {
  return (
    <div className="empty" data-testid={testId}>
      {icon ? (
        <span className="empty__icon">
          <Icon name={icon} size={22} />
        </span>
      ) : null}
      <p className="empty__title">{title}</p>
      {hint ? <p className="empty__hint">{hint}</p> : null}
    </div>
  );
}
